import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useAPHChartsDataContext } from './hooks/useAPHChartsDataContext';

export const OcurrenceListByAPHType = () => {
    const { chartData } = useAPHChartsDataContext();

    const tableColumns = [
            {
                key: 'aph_regulacao',
                header: 'Tipo de APH (Regulação)',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'com_regulacao',
                header: 'Com Regulação',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'sem_regulacao',
                header: 'Sem Regulação',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Ocorrências',
                headerStyle: { fontWeight: '500', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={chartData.ocurrenceListByAPHType}
                columns={tableColumns}
                title="Ocorrências por tipo de APH (Regulação)"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};